module.exports = __webpack_public_path__ + "assets/img/MatrixBAPC.4740c362.png";